var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddRow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_11",
  "data-name": "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.3,3v-.2l.4-.6.7-.2h11.9v1H1.3ZM1.3,6v-1h12.9v1H1.3ZM1.3,9v-1h7.7v1H1.3ZM1.6,12v-1h6v1H1.6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5,7c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5,4.5-2,4.5-4.5-2-4.5-4.5-4.5ZM14,12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.3,14.9H1.8c-.3,0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h3.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,14.9h0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,11.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6,11.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.3,10.9H1.8c-.3,0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h3.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.3,7H1.8c-.3,0-.5-.2-.5-.5V2.5c0-.3.2-.5.5-.5h3.5"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddRow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addRow.315f735482db602fdc5891cd78ea992b.svg";